import { initMotion } from "./modules/motion.js";
import { initSignup } from "./modules/signup.js";
import { initCalculator } from "./modules/calculator.js";
import { initWidgets } from "./modules/widgets.js";

// Behavior first, motion last: a failure in the animation layer must never
// take the forms or the calculator down with it.
document.addEventListener("DOMContentLoaded", () => {
  initSignup();
  initCalculator();
  initWidgets();

  try {
    initMotion();
  } catch (error) {
    // Show everything the animations would have revealed.
    document.documentElement.classList.remove("has-js");
    console.error("[whatitranme] motion disabled:", error);
  }
});
